import { z } from 'zod';

export const publicTemplateAssetIdentitySchema = z
  .object({
    dataSourceId: z
      .string()
      .regex(/^[a-zA-Z0-9_-]+$/)
      .max(64),
    uploadId: z
      .string()
      .regex(/^[a-zA-Z0-9_-]+$/)
      .max(64),
    extension: z
      .string()
      .regex(/^[a-z0-9]+$/)
      .max(16)
  })
  .strict();

export const publicTemplateAssetSchema = publicTemplateAssetIdentitySchema
  .extend({
    key: z.string().min(1),
    sha256: z.string().regex(/^[a-f0-9]{64}$/),
    sizeBytes: z.number().int().positive()
  })
  .strict();

export const publicTemplateAssetsSchema = z.array(publicTemplateAssetSchema);
